"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupDirectDebitConfirmUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var SetupDirectDebitConfirmUI = function () {
    var _a;
    var _b = (0, core_1.useComponents)(), Card = _b.Card, Heading1 = _b.Heading1;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.SETUP_DD_CONFIRM, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement("section", null,
            react_1.default.createElement(Card, { "data-testid": "setup-dd-success" },
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "setupDirectDebitConfirmationHeading" })),
                react_1.default.createElement(Copy, { copyKey: "setupDirectDebitConfirmationBody" })))));
};
exports.SetupDirectDebitConfirmUI = SetupDirectDebitConfirmUI;
